export default __webpack_public_path__ + "static/media/raya-bg.76fb3c77.png";